const listaDeMetodos = (state) => {
    return state.items;
}

const loadingMetodos = (state) => {
    return state.carregando
}

export {
    listaDeMetodos,
    loadingMetodos
}